import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.defaultMinSize
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.layout.wrapContentHeight
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.Button
import androidx.compose.material.ButtonDefaults
import androidx.compose.material.Card
import androidx.compose.material.MaterialTheme
import androidx.compose.material.Surface
import androidx.compose.material.Text
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.layout.onSizeChanged
import androidx.compose.ui.platform.LocalUriHandler
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import androidx.compose.ui.window.Dialog
import androidx.compose.ui.window.DialogProperties
import gsb_kundalibhagya_website.composeapp.generated.resources.Res
import gsb_kundalibhagya_website.composeapp.generated.resources.mac
import gsb_kundalibhagya_website.composeapp.generated.resources.windows
import gsb_kundalibhagya_website.composeapp.generated.resources.apple
import gsb_kundalibhagya_website.composeapp.generated.resources.facebook
import gsb_kundalibhagya_website.composeapp.generated.resources.google
import gsb_kundalibhagya_website.composeapp.generated.resources.headerGSB
import gsb_kundalibhagya_website.composeapp.generated.resources.ic_launcher_playstore
import gsb_kundalibhagya_website.composeapp.generated.resources.instagram
import gsb_kundalibhagya_website.composeapp.generated.resources.landscape
import gsb_kundalibhagya_website.composeapp.generated.resources.landscape_vypar
import gsb_kundalibhagya_website.composeapp.generated.resources.mail
import gsb_kundalibhagya_website.composeapp.generated.resources.playstore
import gsb_kundalibhagya_website.composeapp.generated.resources.portrait
import gsb_kundalibhagya_website.composeapp.generated.resources.qr
import gsb_kundalibhagya_website.composeapp.generated.resources.twitter
import gsb_kundalibhagya_website.composeapp.generated.resources.vyaparicon
import gsb_kundalibhagya_website.composeapp.generated.resources.webapp
import gsb_kundalibhagya_website.composeapp.generated.resources.whatsapp
import gsb_kundalibhagya_website.composeapp.generated.resources.x
import org.jetbrains.compose.resources.painterResource
import theme.InterBold

@Composable
fun AppV() {
    var showDialog by remember { mutableStateOf(false) }
    MaterialTheme {
        var portrait by remember { mutableStateOf(false) }
        val uriHandler = LocalUriHandler.current
        Surface(
            modifier = Modifier.fillMaxSize(),
            color = MaterialTheme.colors.background
        ) {
            Box(Modifier.fillMaxSize().onSizeChanged {
                portrait = it.width < it.height
            }) {
                Box(
                    modifier = Modifier.fillMaxSize().background(Color(0xFFFF9933)),
                )
                Column(Modifier.fillMaxSize()) {
                    Row(
                        modifier = Modifier.fillMaxWidth().height(80.dp).background(Color.White)
                            .padding(10.dp),
                        verticalAlignment = Alignment.CenterVertically,
                    ) {
                        Image(
                            painterResource(Res.drawable.playstore),
                            contentDescription = "Icon",
                        )
                        Spacer(Modifier.width(10.dp))
                        Text(
                            text = "GSB-VyaparBhagya",
                            color = Color.Black,
                            fontSize = 24.sp,
                            fontFamily = InterBold(),
                            fontWeight = FontWeight(600),
                            modifier = Modifier,
                        )
                    }
                    Spacer(Modifier.height(30.dp))
                    LazyColumn {
                        item {
                            Box(
                                modifier = Modifier.fillMaxWidth()
                                    .padding(horizontal = 25.dp, vertical = 25.dp).background(
                                        brush = Brush.linearGradient(
                                            colors = listOf(
                                                Color(0xFFF0F0F0),
                                                Color(0xFFE8E8E8),
                                                Color(0xFFD0D0D0),
                                                Color(0xFFC8C8C8),
                                                Color(0xFFF5F5F5),
                                            )
                                        ),
                                        shape = RoundedCornerShape(12.dp)
                                    ),
                            ) {
                                Column(horizontalAlignment = Alignment.CenterHorizontally, modifier = Modifier.padding(12.dp)) {
                                    Text(
                                        text = "About GSB-VyaparBhagya",
                                        color = Color.Black,
                                        fontSize = 18.sp,
                                        fontFamily = InterBold(),
                                        fontWeight = FontWeight(600),
                                        modifier = Modifier,
                                    )
                                    Spacer(Modifier.height(15.dp))
                                    Text(
                                        text = "GSB-VyaparBhagya is a FREE Business Listing Application exclusively for Konkani speaking GSB community.",
                                        color = Color(0xFF333333),
                                        fontSize = 14.sp,
                                        fontFamily = InterBold(),
                                        fontWeight = FontWeight(600),
                                        modifier = Modifier,
                                        textAlign = TextAlign.Center
                                    )
                                    Spacer(Modifier.height(15.dp))
                                    Image(
                                        painterResource(Res.drawable.vyaparicon),
                                        contentDescription = "Icon",
                                        modifier = Modifier.width(300.dp).height(300.dp)
                                    )
                                    Spacer(Modifier.height(15.dp))
                                    Text(
                                        text = "GSB-VyaparBhagya is a dedicated business listing platform exclusively for the GSB-Konkani community, helping members discover and support local businesses.\n" +
                                                "List your business for free and connect with potential customers within the GSB network, fostering growth and community support.\n" +
                                                "Join today and showcase your services, making it easier for the GSB-Konkani community to find and connect with you!\n" +
                                                "For any assistance/ suggestion/ feedback, feel free to contact us at: ",
                                        color = Color(0xFF333333),
                                        fontSize = 14.sp,
                                        fontFamily = InterBold(),
                                        fontWeight = FontWeight(600),
                                        modifier = Modifier,
                                        textAlign = TextAlign.Center
                                    )
                                    Spacer(Modifier.height(15.dp))
                                    Text(
                                        text = "gsbvyaparbhagya@gmail.com",
                                        color = Color.Blue,
                                        fontSize = 14.sp,
                                        fontFamily = InterBold(),
                                        fontWeight = FontWeight(600),
                                        modifier = Modifier.clickable {
                                            uriHandler.openUri("mailto:gsbvyaparbhagya@gmail.com")
                                        },
                                        textAlign = TextAlign.Center
                                    )
                                    Spacer(Modifier.height(15.dp))
                                    Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.SpaceEvenly) {
                                        Image(
                                            painterResource(Res.drawable.facebook),
                                            contentDescription = "Icon",
                                            modifier = Modifier.width(30.dp).height(30.dp).clickable {
                                                uriHandler.openUri("https://www.facebook.com/gsbvyaparbhagya")
                                            }
                                        )
                                        Image(
                                            painterResource(Res.drawable.x),
                                            contentDescription = "Icon",
                                            modifier = Modifier.width(30.dp).height(30.dp).clickable {
                                                uriHandler.openUri("https://x.com/gsbvyaparbhagya")
                                            }
                                        )
                                        Image(
                                            painterResource(Res.drawable.instagram),
                                            contentDescription = "Icon",
                                            modifier = Modifier.width(30.dp).height(30.dp).clickable {
                                                uriHandler.openUri("https://www.instagram.com/gsbvyaparbhagya")
                                            }
                                        )
                                        Image(
                                            painterResource(Res.drawable.mail),
                                            contentDescription = "Icon",
                                            modifier = Modifier.width(30.dp).height(30.dp).clickable {
                                                uriHandler.openUri("mailto:gsbvyaparbhagya@gmail.com")
                                            }
                                        )
                                        Image(
                                            painterResource(Res.drawable.whatsapp),
                                            contentDescription = "Icon",
                                            modifier = Modifier.width(30.dp).height(30.dp).clickable {
                                                uriHandler.openUri("https://wa.me/+919036195046")
                                            }
                                        )
                                    }
                                    Spacer(Modifier.height(30.dp))
                                    Text(
                                        text = "App is available for Android, iOS, Web & Desktop",
                                        color = Color.Black,
                                        fontSize = 24.sp,
                                        fontFamily = InterBold(),
                                        fontWeight = FontWeight(600),
                                        modifier = Modifier,
                                        textAlign = TextAlign.Center
                                    )
                                    Spacer(Modifier.height(15.dp))
                                    Row(horizontalArrangement = Arrangement.SpaceAround) {
                                        Image(
                                            painter = painterResource(Res.drawable.google),
                                            contentDescription = "Icon",
                                            modifier = Modifier.width(80.dp).height(30.dp).clickable {
                                                uriHandler.openUri("https://play.google.com/store/apps/details?id=com.gsb.vyapar.bhagya.android")
                                            },
                                            alignment = Alignment.Center
                                        )
                                        Spacer(Modifier.width(25.dp))
                                        Image(
                                            painter = painterResource(Res.drawable.apple),
                                            contentDescription = "Icon",
                                            modifier = Modifier.width(80.dp).height(30.dp).clickable {
                                                uriHandler.openUri("https://apps.apple.com/in/app/gsb-vyaparbhagya/id6743987443")
                                            },
                                            alignment = Alignment.Center
                                        )
                                        Spacer(Modifier.width(25.dp))
                                        Image(
                                            painter = painterResource(Res.drawable.webapp),
                                            contentDescription = "Icon",
                                            modifier = Modifier.width(80.dp).height(30.dp).clickable {
                                                uriHandler.openUri("https://app.gsbvyaparbhagya.in")
                                            },
                                            alignment = Alignment.Center
                                        )
                                    }
                                    Spacer(Modifier.height(15.dp))
                                    Row(horizontalArrangement = Arrangement.SpaceAround) {
                                        Image(
                                            painter = painterResource(Res.drawable.windows),
                                            contentDescription = "Icon",
                                            modifier = Modifier.width(50.dp).height(50.dp).clickable {
                                                uriHandler.openUri("https://drive.google.com/uc?export=download&id=1XpZ6W5wBOvFVbQtx5z8XvxhMOaEM_WYh")
                                            },
                                            alignment = Alignment.Center
                                        )
                                        Spacer(Modifier.width(25.dp))
                                        Image(
                                            painter = painterResource(Res.drawable.mac),
                                            contentDescription = "Icon",
                                            modifier = Modifier.width(50.dp).height(50.dp).clickable {
                                                uriHandler.openUri("https://apps.apple.com/in/app/gsb-vyaparbhagya/id6743987443")
                                            },
                                            alignment = Alignment.Center
                                        )
                                    }
                                    Spacer(Modifier.height(30.dp))
                                    Text(
                                        text = "Support Us",
                                        color = Color.Black,
                                        fontSize = 24.sp,
                                        fontFamily = InterBold(),
                                        fontWeight = FontWeight(600),
                                        modifier = Modifier,
                                    )
                                    Spacer(Modifier.height(15.dp))
                                    Image(
                                        painter = painterResource(Res.drawable.qr),
                                        contentDescription = "Icon",
                                        modifier = Modifier.width(200.dp).height(200.dp).clickable {

                                        },
                                        alignment = Alignment.CenterStart
                                    )
                                    Spacer(Modifier.height(15.dp))
                                    Text(
                                        text = "Our services are FREE, however there is a cost involved in managing & maintaining the service, \nWe request you to please support us in any small way possible by either donation  or by sharing the GSB-VyaparBhagya Application among your family and friends \nThank You",
                                        color = Color(0xFF333333),
                                        fontSize = 14.sp,
                                        fontFamily = InterBold(),
                                        fontWeight = FontWeight(600),
                                        modifier = Modifier,
                                        textAlign = TextAlign.Center
                                    )
                                    Spacer(Modifier.height(15.dp))
                                    Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.SpaceEvenly) {
                                        Text(
                                            text = "Privacy Policy",
                                            color = Color.Blue,
                                            fontSize = 14.sp,
                                            fontFamily = InterBold(),
                                            fontWeight = FontWeight(600),
                                            modifier = Modifier.clickable {
                                                uriHandler.openUri("https://docs.google.com/document/d/e/2PACX-1vSP1TbCLV1rnmlKba4HzAbH2gWnMc9OMxsEMOnVqHjOUp_tY64-yzTdR8SDhtKlCWDaPBanupBBANIU/pub?urp=gmail_link")
                                            },
                                            textAlign = TextAlign.Center
                                        )
                                        Text(
                                            text = "Terms & Conditions",
                                            color = Color.Blue,
                                            fontSize = 14.sp,
                                            fontFamily = InterBold(),
                                            fontWeight = FontWeight(600),
                                            modifier = Modifier.clickable {
                                                uriHandler.openUri("https://docs.google.com/document/d/e/2PACX-1vRiGDmiky7JUuwolg0WrFQSdcwaa0qRCJLJIFEZOweamLcmzjXhdt15h0OoOWKuXHhKPoIWTj51EU-5/pub?urp=gmail_link")
                                            },
                                            textAlign = TextAlign.Center
                                        )
                                    }
                                    Spacer(Modifier.height(30.dp))
                                }
                            }
                        }
                    }
                }
            }
        }
    }
    if (showDialog) DialogView() { showDialog = false }
}

@Composable
fun DialogView(hide: () -> Unit) {
    Dialog(
        onDismissRequest = { },
        properties = DialogProperties(
            dismissOnBackPress = false,
            dismissOnClickOutside = false,
            usePlatformDefaultWidth = false
        )
    ) {
        Column(
            modifier = Modifier.width(260.dp).wrapContentHeight()
                .background(Color.White, shape = RoundedCornerShape(20.dp))
                .padding(all = 22.dp), horizontalAlignment = Alignment.CenterHorizontally
        ) {
            Spacer(modifier = Modifier.height(20.dp))
            Text(
                text = "Will come soon!!!",
                color = Color.Black,
                fontSize = 18.sp,
                modifier = Modifier.padding(bottom = 20.dp).padding(horizontal = 16.dp),
                textAlign = TextAlign.Center,
                fontWeight = FontWeight.SemiBold
            )
            Spacer(Modifier.height(8.dp))
            Button(
                onClick = { hide() },
                modifier = Modifier.height(48.dp).fillMaxWidth(),
                shape = RoundedCornerShape(25.dp),
                elevation = ButtonDefaults.elevation(),
                colors = ButtonDefaults.buttonColors(
                    backgroundColor = Color(0xFFFF9933),
                    contentColor = Color.White
                )
            ) {
                Text(text = "OK", color = Color.White)
            }
        }
    }
}
